import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  BillingCycleOption,
  UpgradeRoutingParams,
  UserBillingType,
} from 'globals/types';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { useBillingType } from 'globals/hooks/useBillingType';
import { revertSlugify } from 'globals/utils';
import FsGridContainer from 'ui-elements/grid/FsGridContainer';
import FsGridItem from 'ui-elements/grid/FsGridItem';
import {
  DynamicLine,
  OptionWrapper,
} from './BillingCycleOptions.style-elements';
import {
  getBillingCycleOptionProps,
  getBillingCycleSpecialOption,
} from './BillingCycleOptions.utils';
import BillingCycleOptionItem from './BillingCycleOptionItem';

const BillingCycleOptions: React.FC = () => {
  const { cycle: slugCycle } = useParams<UpgradeRoutingParams>();
  const cycle = revertSlugify(slugCycle);
  const isBillingTypeEnterprise = useBillingType(UserBillingType.ENTERPRISE);
  const initialActiveId = cycle === BillingCycleOption.MONTHLY ? 0 : 1;
  const [activeId, setActiveId] = useState<number>(initialActiveId);
  const [hoverId, setHoverId] = useState<number>();
  const theme = useTheme();
  const isUpSm = useMediaQuery(theme.breakpoints.up('sm'), {
    noSsr: true,
  });

  const options = isBillingTypeEnterprise
    ? [getBillingCycleSpecialOption()]
    : getBillingCycleOptionProps();

  return (
    <>
      {isBillingTypeEnterprise ? (
        <>
          <FsGridContainer>
            {options.map(({ id, ...otherProps }) => (
              <FsGridItem xs={12} key={id}>
                <BillingCycleOptionItem
                  {...{ id, ...otherProps }}
                  showTabIcon={false}
                  isActive
                />
              </FsGridItem>
            ))}
          </FsGridContainer>
          <DynamicLine fullWidth />
        </>
      ) : (
        <>
          <FsGridContainer>
            {options.map(({ id, ...otherProps }) => (
              <FsGridItem xs={12} sm={6} key={id}>
                <OptionWrapper
                  onClick={() => setActiveId(id)}
                  onMouseEnter={() => setHoverId(id)}
                  onMouseLeave={() => setHoverId(undefined)}
                >
                  <BillingCycleOptionItem
                    {...{ id, ...otherProps }}
                    isActive={id === activeId}
                    isHover={id === hoverId}
                  />
                </OptionWrapper>
              </FsGridItem>
            ))}
          </FsGridContainer>
          {isUpSm && <DynamicLine isRight={activeId === 1} />}
        </>
      )}
    </>
  );
};

export default BillingCycleOptions;
